// extracted by mini-css-extract-plugin
module.exports = {"reviewStar":"ReviewsHeader_reviewStar__S_JdC","reviewStarMobile":"ReviewsHeader_reviewStarMobile__Fc6ws","textColor":"ReviewsHeader_textColor__W_w_J"};